export const notFoundPage = {
  seoTitle: "Page Not Found | General Applications",
  seoDescription:
    "The page you requested may have been moved, renamed, or never existed on the General Applications site.",
  headline: "That page does not exist here.",
  copy: "The page you requested may have been moved, renamed, or never existed on this site.",
  cta: "Return Home",
} as const;
